import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';

import ItemView from 'components/layout/item/ItemView';

import DocMeta from 'components/DocMeta';
import { generateMetaTags } from 'helpers/metaTags';

class CarDetails extends React.Component {
  generateMetaTags() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
    } = this.props;

    let title;
    if (entityLoaded) {
      title = entity.getName();
    }
    title = title || messages.meta.car_details.title;

    return [
      { name: 'title', content: title },
      { name: 'description', content: messages.meta.car_details.description },
      { itemProp: 'name', content: messages.meta.car_details.name },
      { itemProp: 'description', content: messages.meta.car_details.description },
      { itemProp: 'image', content: 'http://www.example.com/image.jpg' },
    ];
  }

  render() {
    const {
      intl: { messages },
      appIntl,
      entity,
      entityLoaded,
      entityChanged,
      changeEntity,
    } = this.props;

    const crumbs = [
      { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
      { link: appIntl.urlPrefix + 'account/cars', name: messages.cars },
    ];

    const metaTitle = entityLoaded ? entity.getName() : null;

    return (
      <DocMeta tags={generateMetaTags(messages.meta.car_details, metaTitle)}>
        <ItemView
          itemId={this.props.match.params.itemId}
          editCar
          crumbs={crumbs}
          entity={entity}
          entityLoaded={entityLoaded}
          entityChanged={entityChanged}
          changeEntity={changeEntity}
        />
      </DocMeta>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(CarDetails)));
